import { useMemo, useState } from "react";
import { heroCover, topRankList, highScoreList, newReleaseList, classicList } from "@/mocks/manhwa";

const quickChips = ["奇幻冒险", "恋爱甜宠", "热血战斗", "悬疑惊悚", "治愈日常"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const results = useMemo(() => {
    const kw = keyword.trim();
    if (!kw) return [];
    const all = [...topRankList, ...highScoreList, ...newReleaseList, ...classicList];
    return all.filter((item) => item.title.includes(kw) || item.genre.includes(kw) || item.tags.some((t) => t.includes(kw)));
  }, [keyword]);

  const goRank = (kw?: string) => {
    const target = document.getElementById("ranking");
    if (target) target.scrollIntoView({ behavior: "smooth" });
    if (kw) setKeyword(kw);
  };

  return (
    <section id="top" className="relative flex min-h-[88vh] items-center justify-center overflow-hidden">
      <img
        src={heroCover}
        alt="好看的韩国漫画热门作品合集插画"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
          <i className="ri-fire-fill text-primary-300"></i>
          全网最好看的韩国漫画，一次给你列全
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-white md:text-5xl">
          好看的韩国漫画排行榜
          <span className="mt-2 block text-xl font-bold text-primary-200 md:text-2xl">评分高 · 人气高 · 必看榜</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          从高分神作到热门新作，我们把值得追的韩国漫画一网打尽。告别书荒，帮你快速锁定那一部真正对味的好作品。
        </p>

        <form
          className="mx-auto mt-8 flex w-full max-w-xl items-center gap-2 rounded-full border border-white/20 bg-white/95 p-1.5 shadow-lg backdrop-blur"
          onSubmit={(e) => {
            e.preventDefault();
            goRank(keyword);
          }}
        >
          <i className="ri-search-line ml-3 text-lg text-foreground-400"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索漫画名称、分类或标签，如：奇幻"
            className="h-10 flex-1 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="h-10 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            搜作品
          </button>
        </form>

        {results.length > 0 && (
          <div className="mx-auto mt-2 w-full max-w-xl rounded-2xl border border-background-200 bg-white p-2 text-left shadow-xl">
            {results.slice(0, 6).map((item) => (
              <button
                key={item.title}
                type="button"
                onClick={() => goRank(item.title)}
                className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left hover:bg-background-100"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-sm font-bold text-primary-700">
                  {item.genre.slice(0, 1)}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-semibold text-foreground-900">{item.title}</span>
                  <span className="block text-xs text-foreground-500">{item.genre} · {item.author}</span>
                </span>
                <span className="text-sm font-bold text-primary-600">{item.score.toFixed(1)}</span>
              </button>
            ))}
          </div>
        )}

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {quickChips.map((chip) => (
            <button
              key={chip}
              type="button"
              onClick={() => goRank(chip)}
              className="whitespace-nowrap rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-sm text-white backdrop-blur-sm transition-colors hover:bg-white/20"
            >
              {chip}
            </button>
          ))}
        </div>

        <dl className="mx-auto mt-10 grid max-w-xl grid-cols-3 gap-4">
          {[
            { n: "320+", l: "收录作品" },
            { n: "9.5+", l: "高分神作均分" },
            { n: "10w+", l: "每周读者好评" },
          ].map((s) => (
            <div key={s.l} className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-sm">
              <dt className="text-sm text-white/75">{s.l}</dt>
              <dd className="mt-1 font-heading text-2xl font-black text-white md:text-3xl">{s.n}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}